module.exports = __webpack_public_path__ + "assets/img/Eimele-2-Landing-Page-w540.ff47c0cc.webp";